<template>
  <b-container fluid class="pb-4">
    <h1 class="fc-h1">{{ $i18n.t("state.title") }}</h1>
    <div class="m-4">
      <b-form inline class="mb-3">
        <label class="mr-2" for="inline-form-custom-select-pref">{{ $i18n.t("state.label_line") }}</label>
        <b-form-select v-model="lineSelected" :options="lines" class="mr-2" @change="lineChange"></b-form-select>
        <label class="ml-4 mr-2" for="inline-form-custom-select-pref">{{ $i18n.t("state.label_code") }}</label>
        <b-form-select v-model="modelSelected" :options="models" class="ml-4 mr-2" @change="modelChange"></b-form-select>
        <label class="ml-4 mr-2" for="inline-form-custom-select-pref">{{ $i18n.t("state.label_ok_max") }}</label>
        <input type="text" v-model="message" class="ml-4 mr-2 form-control" @change="changeGraphMax" value="100" maxlength="6" />
        <input type="text" class="ml-4 mr-2 form-control" style="display:none" />
      </b-form>

      <table :fields="fields" :items="items" class="fc-andon-line">
        <thead class="fc-andon-all thead">
          <tr>
            <td>{{ $i18n.t("state.label_process") }}</td>
            <td>{{ $i18n.t("state.label_make_count") }} {{ $i18n.t("state.label_sum") }}</td>
            <td>{{ $i18n.t("state.label_make_count") }} {{ $i18n.t("state.label_graph") }}</td>
            <td>{{ $i18n.t("state.label_ng_count") }}</td>
            <td>{{ $i18n.t("state.label_stock_count") }}</td>
            <td>{{ $i18n.t("state.label_stock_count") }} {{ $i18n.t("state.label_graph") }}</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in items" :key="index">
            <td style="text-align: center;">{{row.process}}</td>
            <td>{{row.num_ok_all}}</td>
            <td>
              <b-progress :max="max[0]">
                <b-progress-bar :value=row.num_ok_all class="fc-bar-a"></b-progress-bar>
              </b-progress>
            </td>
            <td>{{row.num_ng}}</td>
            <td>{{row.num_stock_all}}</td>
            <td>
              <b-progress :max="max[1]">
                <b-progress-bar :value=row.num_stock_all class="fc-bar-b"></b-progress-bar>
              </b-progress>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <confirm-modal modId="md-err" :msg="errMsg" :titleMsg="errSbj" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="errConfirm"/>
  </b-container>
</template>

<script>
import confirmModal from './ConfirmModal'
export default {
  data () {
    return {
      intervalId: undefined,
      errMsgShow: false,
      message: '100',
      defaultMax: '100',
      lineSelected: null,
      modelSelected: null,
      errMsg: null,
      errSbj: null,
      models: [
        { value: null, text: this.$i18n.t('state.label_all_code') }
      ],
      lines: [
      ],
      fields: [
        { key: 'process', label: '' },
        { key: 'num_ok_all', label: '製造数' },
        { key: 'num_ng', label: '不良数' },
        { key: 'num_stock_all', label: '在庫' }
      ],
      max: [100, 100],
      items: [
      ]
    }
  },
  components: {
    confirmModal
  },
  async created () {
    document.body.style.overflow = 'hidden'
    this.$store.store.state.loading = true
    var searchLineId = null
    var defaultLine = this.$route.query.lineId
    var headers = {
      'Content-Type': 'application/json',
      'opId': this.$store.store.state.opId,
      'ticketId': this.$store.store.state.ticketId
    }

    // ラインプルダウン取得
    var linebody = {}
    linebody.efFlg = '1'

    await this.$axios
      .post(window.END_POINT + '/master/line/select', linebody, {
        'headers': headers
      })
      .then(res => {
        if (res.data.result !== 'OK') {
          if (res.data.result === '401') {
            // ログインしていない場合
            this.$router.push('/')
          } else {
            if (this.errMsgShow === false) {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
              this.errMsgShow = true
            }
          }
        } else {
          var lineList = res.data.lineInfo
          var lines = []
          // 整形
          for (var i = 0; i < lineList.length; i++) {
            var option = {}
            option.value = lineList[i].line_id
            option.text = lineList[i].line_name + ' (' + lineList[i].base_name + ')'
            lines.push(option)
          }
          // 一旦データクリア
          this.lines.splice(1)
          // データセット
          this.lines.splice(1, 0, ...lines)

          // パラメータ取得
          if (defaultLine === undefined) {
            // パラメータがない場合は表示順が最も早い値を表示
            this.lineSelected = this.lines[0].value
            searchLineId = this.lines[0].value
          } else {
            var def = String(defaultLine)
            for (var t = 0; t < this.lines.length; t++) {
              var id = String(this.lines[t].value)
              if (id === def) {
                this.lineSelected = this.lines[t].value
              }
            }
          }
        }
      })
      .catch(res => {
        this.$store.store.state.loading = false
        document.body.style.overflow = 'auto'
        if (this.errMsgShow === false) {
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
          this.errMsgShow = true
        }
        console.log(res)
      })

    // 型番プルダウン取得
    var modelbody = {}
    modelbody.efFlg = '1'

    this.$axios
      .post(window.END_POINT + '/master/productinfo/select', modelbody, {
        'headers': headers
      })
      .then(res => {
        if (res.data.result !== 'OK') {
          if (res.data.result === '401') {
            // ログインしていない場合
            this.$router.push('/')
          } else {
            if (this.errMsgShow === false) {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
              this.errMsgShow = true
            }
          }
        } else {
          var modelList = res.data.productInfo
          var models = []

          // 整形
          for (var i = 0; i < modelList.length; i++) {
            var option = {}
            option.value = modelList[i].code + ',' + modelList[i].rev
            option.text = modelList[i].code + ' - ' + modelList[i].rev + ' - ' + modelList[i].petname
            models.push(option)
          }
          // 一旦データクリア
          this.models.splice(1)
          // データセット
          this.models.splice(1, 0, ...models)
        }
      })
      .catch(res => {
        this.$store.store.state.loading = false
        document.body.style.overflow = 'auto'
        if (this.errMsgShow === false) {
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
          this.errMsgShow = true
        }
        console.log(res)
      })

    // ライン別製造進捗取得
    var searchLineBody = {}
    if (defaultLine === undefined) {
      // パラメータがない場合は表示順が最も早い値を表示
      searchLineBody.line = String(searchLineId)
    } else {
      searchLineBody.line = String(defaultLine[0])
    }
    searchLineBody.model = ''

    // 日付取得
    var dates = await this.getSearchDate()
    searchLineBody.start = String(dates.start)
    searchLineBody.end = String(dates.end)

    this.$axios
      .post(window.END_POINT + '/state/line', searchLineBody, {
        'headers': headers
      })
      .then(res => {
        if (res.data.result !== 'OK') {
          if (res.data.result === '401') {
            // ログインしていない場合
            this.$router.push('/')
          } else {
            if (this.errMsgShow === false) {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
              this.errMsgShow = true
            }
            // データクリア
            this.dataSet([])
          }
        } else {
          // 取得データセット
          this.dataSet(res.data.processList)
        }
      })
      .catch(res => {
        this.$store.store.state.loading = false
        document.body.style.overflow = 'auto'
        if (this.errMsgShow === false) {
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
          this.errMsgShow = true
        }
        // データクリア
        this.dataSet([])
        console.log(res)
      })
    // 1分ごとに定期実行するよう設定
    this.intervalId = window.setInterval(this.getLineStates, 60000)
    this.$store.store.state.loading = false
    document.body.style.overflow = 'auto'
  },
  methods: {
    getLineStates: async function () {
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }
      // ラインID, 型番取得
      var lineID = this.lineSelected
      var model = this.modelSelected

      var body = {}
      if (lineID != null) {
        body.line = String(lineID)
      }
      if (model != null) {
        var code = model.split(',')
        body.model = code[0]
        body.rev = code[1]
      }

      // 日付取得
      var dates = await this.getSearchDate()
      body.start = String(dates.start)
      body.end = String(dates.end)

      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/state/line', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              if (this.errMsgShow === false) {
                this.errSbj = this.$i18n.t('common.title_modal_error')
                this.errMsg = this.$i18n.t(res.data.message)
                this.$bvModal.show('md-err')
                this.errMsgShow = true
              }
              // データクリア
              this.dataSet([])
            }
          } else {
            // 取得データセット
            this.dataSet(res.data.processList)
            // 正常にデータ取得できたので、エラー表示フラグリセット
            this.errMsgShow = false
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (this.errMsgShow === false) {
            this.errSbj = this.$i18n.t('common.title_modal_error')
            this.errMsg = this.$i18n.t('common.unexpected_error')
            this.$bvModal.show('md-err')
            this.errMsgShow = true
          }
          // データクリア
          this.dataSet([])
          console.log(res)
        })
    },
    getSearchDate: async function () {
      var startTime = ''
      var dates_ = []
      // 開始時間取得
      var reqObj = {}
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      await this.$axios
        .post(window.END_POINT + '/common/selectStartTime', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              if (this.errMsgShow === false) {
                this.errSbj = this.$i18n.t('common.title_modal_error')
                this.errMsg = this.$i18n.t(res.data.message)
                this.$bvModal.show('md-err')
                this.errMsgShow = true
              }
            }
          } else {
            startTime = res.data.shift_start_time
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (this.errMsgShow === false) {
            this.errSbj = this.$i18n.t('common.title_modal_error')
            this.errMsg = this.$i18n.t('common.unexpected_error')
            this.$bvModal.show('md-err')
            this.errMsgShow = true
          }
          console.log(res)
        })

      // 日またぎ確認、時間取得
      var nowTime = window.formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss')
      dates_ = window.getStartTime(startTime, nowTime, true)

      var dates = []
      // 作業開始時間をUTCに変換
      var startLocal = this.setUTCDate(dates_.start, 'YYYY/MM/DD hh:mm:ss')
      var obj = this.$moment(startLocal, 'YYYY/MM/DD HH:mm:ss')
      var utcStrStart = obj.utc().format('YYYY/MM/DD HH:mm:ss')
      dates.start = utcStrStart

      // 現在時刻をUTCに変換
      var endLocal = this.setUTCDate(dates_.end, 'YYYY/MM/DD hh:mm:ss')
      var objEnd = this.$moment(endLocal, 'YYYY/MM/DD HH:mm:ss')
      var utcStrEnd = objEnd.utc().format('YYYY/MM/DD HH:mm:ss')
      dates.end = utcStrEnd

      return dates
    },
    setUTCDate: function (date, format) {
      if (!format) {
        // デフォルト値
        format = 'YYYY/MM/DD hh:mm:ss'
      }
      // フォーマット文字列内のキーワードを日付に置換する
      format = format.replace(/YYYY/g, date.getFullYear())
      format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2))
      format = format.replace(/DD/g, ('0' + date.getDate()).slice(-2))
      format = format.replace(/hh/g, ('0' + date.getHours()).slice(-2))
      format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2))
      format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2))
      return format
    },
    dataSet: function (stateList) {
      // 取得データ整形、在庫数最大値取得
      var states = []
      var stockMax = 0
      for (var i = 0; i < stateList.length; i++) {
        var state = {}
        state.process = stateList[i].process_name
        state.num_ok_all = stateList[i].make_all_count
        state.num_ng = stateList[i].ng_count
        state.num_stock_all = stateList[i].stock_all_count
        stockMax += stateList[i].stock_all_count
        states.push(state)
      }
      // 一旦データクリア
      this.items.splice(0)
      // データセット
      this.items.splice(0, 0, ...states)
      // 在庫数最大値をグラフに設定
      this.max[1] = stockMax
    },
    lineChange: function () {
      // ラインプルダウン変更イベント
      this.getLineStates()
    },
    modelChange: function () {
      // 型番プルダウン変更イベント
      this.getLineStates()
    },
    changeGraphMax: function () {
      // 製造数最大値変更イベント
      // 最大値が未入力or文字なら、デフォルト値に修正
      this.checkMax()
      var inputnum = this.message
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].num_ok_all > inputnum) {
          inputnum = this.items[i].num_ok_all
        }
      }
      this.max[0] = inputnum

      this.getLineStates()
    },
    errConfirm: function () {
      this.$bvModal.hide('md-err')
    },
    checkMax: function () {
      if (!window.checkNum(this.message) || this.message === '') {
        this.message = this.defaultMax
      }
    }
  },
  destroyed: function () {
    clearInterval(this.intervalId)
  }
}
</script>
<style>
.fc-andon-line {
  width: 100%;
  border-collapse: collapse;
  line-height: 1;
  border: 3px solid #999;
}
.fc-andon-line th,
.fc-andon-line td {
  border: 2px solid #999;
  vertical-align: middle;
}
.fc-andon-line thead th {
  border-bottom: 3px solid #999;
}
.fc-andon-line thead th,
.fc-andon-th {
  background-color: rgba(255, 255, 255, 0.05);
  text-align: center;
  font-weight: bold;
  font-size: 1.5rem;
}
.fc-andon-th {
  width: 4em;
}
td.fc-andon-num {
  text-align: right;
  font-size: 2rem;
  padding: 0.75rem 1.5rem !important;
}
</style>
<style scoped>
.progress-bar {
  border-right: 1px solid #272b30;
}
.progress-bar[aria-valuenow="0"] {
  border-right: none;
}
.fc-bar-a {
  background: rgb(3, 175, 122);
}
.fc-bar-b {
  background: rgb(246, 170, 0);
}
.fc-andon-line thead td {
  border: 1px solid #999;
  background-color: rgba(255, 255, 255, 0.05);
  text-align: center;
  padding: 10px;
}
.fc-andon-line tbody th {
  border: 1px solid #999;
  background-color: rgba(255, 255, 255, 0.05);
  font-weight: normal;
  padding: 10px;
  text-align: center;
}
.fc-andon-line tbody td {
  border: 1px solid #ccc;
  text-align: right;
  padding: 10px 20px;
  font-size: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/StateLine.vue